<template>
  <image id="panel13" x="120.5" y="53" width="926.829268" height="500" href="static/module_5/panel13.png" />
</template>

<script>
  export default {
    props: ['name']
  }
</script>



// WEBPACK FOOTER //
// dylan_story_13.vue?339e5d9a